import * as React from 'react';
import { createPortal } from 'react-dom';

const SearchPortalMobileProvider: React.FunctionComponent = ({
  children,
}): React.ReactPortal | null => {
  const searchPortalRoot = document.getElementById('search-portal-mobile');

  return searchPortalRoot && createPortal(children, searchPortalRoot);
};

export default SearchPortalMobileProvider;
